import { Component } from '@angular/core';

@Component({
  selector: 'mc-scheduling-index',
  templateUrl: './scheduling-index.component.html',
  styleUrls: ['./scheduling-index.component.scss']
})
export class SchedulingIndexComponent {
  constructor() { }
}
